import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { medicalStaffService } from "@project/services/admin/medical-staff.service";
import type {
  MedicalStaff,
  MedicalStaffPayload,
} from "@project/types/medical-staff";

const fields: Field[] = [
  {
    name: "name",
    label: "Full Name",
    required: true,
    showInTable: true,
    placeholder: "e.g. Dr. Vinod Panchal",
  },
  {
    name: "staff_type",
    label: "Staff Type",
    type: "select",
    required: true,
    showInTable: true,
    options: [
      { value: "doctor", label: "Doctor" },
      { value: "nurse", label: "Nurse" },
    ],
  },
  {
    name: "qualification",
    label: "Qualification",
    required: true,
    showInTable: true,
    placeholder: "e.g. D.O.M.S.",
  },
  {
    name: "designation",
    label: "Designation / Role",
    required: true,
    showInTable: true,
    placeholder: "e.g. Senior Ophthalmic Surgeon",
  },
  {
    name: "timings",
    label: "Consulting Timings",
    showInTable: true,
    placeholder: "e.g. Monday to Saturday | 9:00 AM to 12:00 PM",
  },
  {
    name: "display_order",
    label: "Display Order",
    type: "number",
    showInTable: true,
    placeholder: "e.g. 1",
  },
  {
    name: "is_highlighted",
    label: "Is Medical In-charge",
    type: "boolean",
    showInTable: true,
  },
  {
    name: "is_active",
    label: "Active Status",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): MedicalStaffPayload {
  return {
    name: String(payload.name ?? "").trim(),
    staff_type: (payload.staff_type as "doctor" | "nurse") || "doctor",
    qualification: String(payload.qualification ?? "").trim(),
    designation: String(payload.designation ?? "").trim(),
    timings: String(payload.timings ?? "").trim(),
    display_order: parseInt(String(payload.display_order ?? "0"), 10) || 0,
    is_highlighted:
      payload.is_highlighted === true || payload.is_highlighted === "true",
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function MedicalStaffPage() {
  return (
    <AdminShell
      title="Medical Staff"
      subtitle="Manage doctor and nurse practitioner records"
    >
      <ApiResourceTable<MedicalStaff>
        title="Medical Staff"
        labelField="name"
        fields={fields}
        searchFields={["name", "qualification", "designation"]}
        defaultValues={{
          is_active: true,
          staff_type: "doctor",
          display_order: 1,
        }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        csvFileName="medical-staff"
        list={query => medicalStaffService.listPage(query)}
        loadRecordForEdit={id => medicalStaffService.get(id)}
        create={payload => medicalStaffService.create(toPayload(payload))}
        update={(id, payload) =>
          medicalStaffService.update(id, toPayload(payload))
        }
        remove={id => medicalStaffService.delete(id)}
      />
    </AdminShell>
  );
}
